export default __webpack_public_path__ + "static/media/1415 spice rack top.8e46ae22.png";